import { render, staticRenderFns } from "./ComparisonIndicator.vue?vue&type=template&id=6a8ca46c&scoped=true"
import script from "./ComparisonIndicator.vue?vue&type=script&lang=js"
export * from "./ComparisonIndicator.vue?vue&type=script&lang=js"
import style0 from "./ComparisonIndicator.vue?vue&type=style&index=0&id=6a8ca46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8ca46c",
  null
  
)

export default component.exports